import React from 'react';
import { getServerURL } from '../../util';


class LoginStatus extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			server: false,
			database: false,
            text: ''
        };
        
        const url = getServerURL();
        window.fetch(`${url}/isalive`)
            .then(res => res.json())
            .then(res => {
                this.setState(res);
            })
            .catch(err => {
                console.log(typeof err);
                console.dir(err);
                this.setState({text: err.toString()});
            })
    }
	
	render() {

		return (
            <div className="status">
                <div className={this.state.server ? 'status__item status__item--online' : 'status__item'}>
                    Server
                </div>
                <div className={this.state.database ? 'status__item status__item--online' : 'status__item'}>
                    Database
                </div>
                <div className="tiny-upper" style={{paddingTop: '0.5rem' }}>{this.state.text}</div>
            </div>
		);
	}
}

export default LoginStatus


// WEBPACK FOOTER //
// ./src/components/user/LoginStatus.js